module.exports = __webpack_public_path__ + "img/Vector2.1e7308c2.png";